"use client"

import { ErrorMessage } from "@/app/error"
import { Card } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { NftActivityTable, NftActivityTableSkeleton } from "./activity-table"

export const NftActivityView = reatomComponent(() => {
  return (
    <NftActivityLayout>
      <ErrorBoundary
        fallback={
          <div className="flex h-full flex-col items-center justify-center">
            <ErrorMessage />
          </div>
        }
      >
        <Suspense fallback={<NftActivityTableSkeleton />}>
          <NftActivityTable />
        </Suspense>
      </ErrorBoundary>
    </NftActivityLayout>
  )
}, "NftActivityView")

export const NftActivityLayout = reatomComponent(
  ({ children }: { children: React.ReactNode }) => {
    return (
      <Card
        className="min-h-[300px] flex-1 overflow-hidden px-2 sm:min-h-[unset]"
        data-testid="nft-activity-table"
      >
        {children}
      </Card>
    )
  },
  "NftActivityLayout",
)
